import { TagsButtonVariants } from "@foodpilot/foods";
import { t } from "i18next";

export type ActionStatus = {
    id: number;
    label: string;
    backendLabel: string | undefined;
    color: TagsButtonVariants;
    display: boolean;
};

export const ACTION_STATUS: ActionStatus[] = [
    // This first item will not show :)
    { id: 0, backendLabel: "no-status", label: t("action-plan.status.no-status"), color: "tags-red", display: false },
    { id: 1, backendLabel: "en réflexion", label: t("action-plan.status.planning"), color: "tags-red", display: true },
    { id: 2, backendLabel: "planifiée", label: t("action-plan.status.planned"), color: "tags-grey", display: true },
    { id: 3, backendLabel: "en cours", label: t("action-plan.status.in-progress"), color: "tags-white", display: true },
    { id: 4, backendLabel: "intégrée", label: t("action-plan.status.review"), color: "tags-green", display: true },
    { id: 5, backendLabel: "terminée", label: t("action-plan.status.done"), color: "tags-green", display: true },
];
